
import React, { useState, useEffect } from 'react';
import {
  Document,
  Page,
  View,
  Text,
  PDFViewer,
  Image,
  StyleSheet,
  pdf
} from '@react-pdf/renderer';

import bannerSuperior from '../src/imagenes/bannerSuperior.png';
import bannerInferior from '../src/imagenes/bannerInferior.png';
import ImagenQR from '../src/tools/imagenQR.jsx';
import Logo from '../src/imagenes/escudoIseP.png';
import logoProvincia from '../src/imagenes/escudoIseP.png';
import textoIsep from '../src/imagenes/logoProvinciaISeP2024.png';
import axios from 'axios';
import DameToken from '../src/tools/dameToken.js';
import { useLocation } from 'react-router-dom';
import { saveAs } from 'file-saver';
import firmaFunc from './firmaSimil.jpeg';


// ============================================================
// TAMAÑO DE VENTANA
// ============================================================
const useWindowSize = () => {

  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  useEffect(() => {

    const handleResize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };

  }, []);

  return windowSize;
};


// ============================================================
// COMPONENTE
// ============================================================
function Constancia() {


  // ============================================================
  // FORMATEAR NÚMERO A TRES DÍGITOS
  // ============================================================
  function formatToThreeDigits(number) {

    if (number < 1 || number > 100) {
      return number;
    }

    return number.toString().padStart(3, '0');
  }


  const { width } = useWindowSize();


  // ============================================================
  // QUERY STRING
  // ============================================================
  function useQuery() {
    return new URLSearchParams(useLocation().search);
  }


  const styles = StyleSheet.create({
    text: {
      fontFamily: 'Tahoma',
      fontSize: 12,
    },
  });


  const [muestro, setMuestro] = useState(false);
  const [Er, setEr] = useState(false);
  const [datosVarios, setDatosVarios] = useState(false);
  const [claseCertificad, setClaseCertificado] = useState();
  const [anio, setanio] = useState();

  const consulta = useQuery();


  // ============================================================
  // FIRMANTE
  // ============================================================
  const firmanteSimil = "Crio. General (r) Dardo E. Simil";
  const firmanteFuncion = "Subsecretario de Formación y Carrera Policial";
  const firmanteDestino = "Ministerio de Justicia y Seguridad";


  // ============================================================
  // MODELO CERTIFICADO
  // IMPORTANTE:
  // Guardamos certificado.createdAt para utilizarlo en TODAS
  // las clases como fecha de emisión.
  // ============================================================
  const certificadoModel = (curso, certificado) => {

    const certificadoFinal = {

      "añoCertificado": strigAFecha(curso.createdAt).getFullYear(),

      // FECHA REAL DE CREACIÓN DEL CERTIFICADO
      "createdAt": curso.createdAt,

      "idCurso": formatToThreeDigits(curso.id),
      "idCursante": formatToThreeDigits(certificado.id),

      "dniCertificado": certificado.dniCertificado,
      "apellidoNombre": certificado.apellidoNombre,

      "reginterno": curso.reginterno,
      "claseCertificado": curso.claseCertificado,
      "tituloCertificado": curso.tituloCertificado,
      "ciudadCertificado": curso.ciudadCertificado,
      "fechaciudadCertificado": curso.fechaciudadCertificado,

      "organizadoPor": curso.organizadoPor,
      "tipoCapacitacion": curso.tipoCapacitacion,
      "fechaRealizado": curso.fechaRealizado,

      "escudo1": curso.escudo1,
      "escudo2": curso.escudo2,

      "fechacursado": curso.fechacursado,
      "cantidadHoras": curso.cantidadHoras,
      "tipoHoras": curso.tipoHoras,

      "sedeCertificado": certificado.sedeCertificado,

      "resolucionCertificado": curso.resolucionCertificado,
      "resolucionJPP": curso.resolucionJPP,

      "grado": certificado.grado,
      "calidadDe": certificado.calidadDe,

      "cantidadFirmas": curso.cantidadFirmas,

      "firma1": curso.firma1,
      "firmante1": curso.firmante1,
      "firmante1jer": curso.firmante1jer,
      "firmante1cargo": curso.firmante1cargo,

      "firma2": curso.cantidadFirmas > 1 ? curso.firma2 : "",
      "firmante2": curso.cantidadFirmas > 1 ? curso.firmante2 : "",
      "firmante2jer": curso.cantidadFirmas > 1 ? curso.firmante2jer : "",
      "firmante2cargo": curso.cantidadFirmas > 1 ? curso.firmante2cargo : "",

      "firma3": curso.cantidadFirmas > 2 ? curso.firma3 : "",
      "firmante3": curso.cantidadFirmas > 2 ? curso.firmante3 : "",
      "firmante3jer": curso.cantidadFirmas > 2 ? curso.firmante3jer : "",
      "firmante3cargo": curso.cantidadFirmas > 2 ? curso.firmante3cargo : "",

      "firma4": curso.cantidadFirmas > 3 ? curso.firma4 : "",
      "firmante4": curso.cantidadFirmas > 3 ? curso.firmante4 : "",
      "firmante4jer": curso.cantidadFirmas > 3 ? curso.firmante4jer : "",
      "firmante4cargo": curso.cantidadFirmas > 3 ? curso.firmante4cargo : "",

      "firma5": curso.cantidadFirmas > 4 ? curso.firma5 : "",
      "firmante5": curso.cantidadFirmas > 4 ? curso.firmante5 : "",
      "firmante5jer": curso.cantidadFirmas > 4 ? curso.firmante5jer : "",
      "firmante5cargo": curso.cantidadFirmas > 4 ? curso.firmante5cargo : ""
    };


    setDatosVarios(certificadoFinal);
    setMuestro(true);
  };


  // ============================================================
  // MES Y AÑO DESDE UNA FECHA
  //
  // EJEMPLO:
  // 2026-09-21T14:30:00.000Z
  // ->
  // septiembre 2026
  // ============================================================
  function mesYAnio(fecha) {
console.log("fecha", fecha);
    if (!fecha) return "";

    const meses = [
      "enero",
      "febrero",
      "marzo",
      "abril",
      "mayo",
      "junio",
      "julio",
      "agosto",
      "septiembre",
      "octubre",
      "noviembre",
      "diciembre"
    ];


    const texto = String(fecha).trim();


    // ========================================================
    // TEXTO LIBRE
    // ========================================================
    const coincidenciaTexto = texto.match(
      /(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)\D*(\d{4})/i
    );

    if (coincidenciaTexto) {

      return `${coincidenciaTexto[1].toLowerCase()} ${coincidenciaTexto[2]}`;
    }


    // ========================================================
    // FECHA ISO
    // 2026-05-20
    // 2026-05-20T00:00:00.000Z
    // ========================================================
    const coincidenciaIso = texto.match(
      /^(\d{4})-(\d{2})-(\d{2})/
    );

    if (coincidenciaIso) {

      const anio = Number(coincidenciaIso[1]);
      const mes = Number(coincidenciaIso[2]);

      if (mes >= 1 && mes <= 12) {
        return `${meses[mes - 1]} ${anio}`;
      }
    }


    // ========================================================
    // FECHA ARGENTINA
    // 20/05/2026
    // ========================================================
    const coincidenciaArgentina = texto.match(
      /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/
    );

    if (coincidenciaArgentina) {

      const mes = Number(coincidenciaArgentina[2]);
      const anio = Number(coincidenciaArgentina[3]);

      if (mes >= 1 && mes <= 12) {
        return `${meses[mes - 1]} ${anio}`;
      }
    }


    // ========================================================
    // OTROS FORMATOS
    // ========================================================
    const fechaConvertida = new Date(texto);

    if (!isNaN(fechaConvertida.getTime())) {

      return `${meses[fechaConvertida.getMonth()]} ${fechaConvertida.getFullYear()}`;
    }


    return "";
  }


  // ============================================================
  // FECHA COMPLETA DESDE CREATEDAT
  //
  // Ej:
  // a los 21 días del mes de SEPTIEMBRE del 2026
  // ============================================================
  function fechaFormalDesdeCreatedAt(fecha) {

    if (!fecha) return "";

    const meses = [
      "ENERO",
      "FEBRERO",
      "MARZO",
      "ABRIL",
      "MAYO",
      "JUNIO",
      "JULIO",
      "AGOSTO",
      "SEPTIEMBRE",
      "OCTUBRE",
      "NOVIEMBRE",
      "DICIEMBRE"
    ];


    const fechaConvertida = new Date(fecha);

    if (isNaN(fechaConvertida.getTime())) {
      return "";
    }


    // Tomamos los valores de la fecha guardada
    const dia = fechaConvertida.getDate();
    const mes = meses[fechaConvertida.getMonth()];
    const anio = fechaConvertida.getFullYear();


    return `a los ${dia} días del mes de ${mes} del ${anio}`;
  }


  // ============================================================
  // FECHA FORMAL ACTUAL
  // Se conserva por compatibilidad.
  // ============================================================
  function fechaFormal() {

    const meses = [
      "enero",
      "febrero",
      "marzo",
      "abril",
      "mayo",
      "junio",
      "julio",
      "agosto",
      "septiembre",
      "octubre",
      "noviembre",
      "diciembre"
    ];

    const hoy = new Date();

    const dia = hoy.getDate();
    const mes = meses[hoy.getMonth()];
    const anio = hoy.getFullYear();

    return `${dia} de ${mes} de ${anio}`;
  }


  // ============================================================
  // STRING A FECHA
  // ============================================================
  function strigAFecha(dateString) {

    const date = new Date(dateString);

    if (isNaN(date)) {
      throw new Error('Fecha inválida');
    }

    return date;
  }


  // ============================================================
  // REEMPLAZAR ESPACIOS
  // ============================================================
  const reemplazarEspacios = (str) => {

    return str.replace(/ /g, '%20');
  };


  // ============================================================
  // DIRECCIÓN QR
  // ============================================================
  const direccion =
    "https://certificados.isepsantafe.edu.ar?ni=" +
    consulta.get("ni") +
    "&curso=" +
    reemplazarEspacios(consulta.get('curso')) +
    "&Ra@=" +
    DameToken();


  // ============================================================
  // OBTENER CERTIFICADO
  // ============================================================
  const obtieneCertificado = async () => {

    const client = axios.create({

      baseURL:
        "https://wwwa.isepsantafe.net.ar/expedientes/certificados/api-devuelveCertificados",

      headers: {

        Authorization: `Bearer ${"Mi clave rompedora"}`,

        "Content-Type": "application/json",
      },
    });


    try {

      const datos = await client.post(
        "/",
        {},
        {
          params: {

            ni: consulta.get("ni"),

            curso: consulta.get("curso"),
          },
        }
      );


      console.log(datos.data);


      if (datos) {

        if (datos.data.Cursante != "Nada que mostrar") {

          /*
           * Conservamos anio por compatibilidad con el
           * número de registro.
           */
          setanio(datos.data.Curso.createdAt);


          /*
           * IMPORTANTE:
           * certificadoModel recibe el cursante/certificado.
           * Ahí guardamos certificado.createdAt.
           */
          certificadoModel(
            datos.data.Curso,
            datos.data.cursante
          );


          setClaseCertificado(
            datos.data.Curso.claseCertificado
          );


          setMuestro(true);

        } else {

          setEr(true);
        }

      } else {

        setEr(true);
      }

    } catch (error) {

      console.log(error);

      setEr(true);
    }
  };


  // ============================================================
  // OBTENER AÑO
  // ============================================================
  const obtenerAnio = (fecha) => {

    return new Date(fecha).getFullYear();
  };


  // ============================================================
  // CARGA INICIAL
  // ============================================================
  useEffect(() => {

    obtieneCertificado();

    return () => {};

  }, []);


  // ============================================================
  // DNI / NI
  // ============================================================
  function verificarString(cadena) {

    if (cadena > 6000000) {

      return "DNI";

    } else {

      return "N.I.";
    }
  }


  // ============================================================
  // FECHA FORMAL 4
  // Se conserva por compatibilidad.
  // ============================================================
  function fechaFormal4() {

    const meses = [
      "enero",
      "febrero",
      "marzo",
      "abril",
      "mayo",
      "junio",
      "julio",
      "agosto",
      "septiembre",
      "octubre",
      "noviembre",
      "diciembre"
    ];


    const hoy = new Date();

    const dia = hoy.getDate();
    const mes = meses[hoy.getMonth()];
    const anio = hoy.getFullYear();


    return `${dia} días del mes de ${mes} de ${anio}`;
  }


  // ============================================================
  // FECHA FORMATEADA ARGENTINA
  // Se conserva aunque ahora las clases utilizan createdAt.
  // ============================================================
  function fechaFormateadaArgentina() {

    const meses = [
      "ENERO",
      "FEBRERO",
      "MARZO",
      "ABRIL",
      "MAYO",
      "JUNIO",
      "JULIO",
      "AGOSTO",
      "SEPTIEMBRE",
      "OCTUBRE",
      "NOVIEMBRE",
      "DICIEMBRE"
    ];


    const ahora = new Date();


    const opcionesFecha = {

      timeZone: "America/Argentina/Buenos_Aires",

      year: "numeric",

      month: "numeric",

      day: "numeric",

      hour: "2-digit",

      minute: "2-digit",

      hour12: false
    };


    const formateador =
      new Intl.DateTimeFormat(
        "es-AR",
        opcionesFecha
      );


    const partes =
      formateador.formatToParts(ahora);


    let dia;
    let mes;
    let año;
    let hora;
    let minuto;


    partes.forEach(({ type, value }) => {

      if (type === "day")
        dia = value;

      if (type === "month")
        mes = meses[parseInt(value) - 1];

      if (type === "year")
        año = value;

      if (type === "hour")
        hora = value.padStart(2, "0");

      if (type === "minute")
        minuto = value.padStart(2, "0");
    });


    return `a los ${dia} días del mes de ${mes} del ${año}`;
  }


  // ============================================================
  // FECHA ÚNICA DEL CERTIFICADO
  //
  // TODAS LAS CLASES UTILIZAN certificado.createdAt
  // ============================================================
  const hoyCertificado =
    mesYAnio(datosVarios?.createdAt)+"";


  const fechaCompletaCertificado =
    fechaFormalDesdeCreatedAt(
      datosVarios?.createdAt
    );


  // ============================================================
  // TEXTOS CLASE 1
  // ============================================================
  const text1Clase1 =
    `Se le otorga el presente certificado al`;


  const text2Clase1 =
    ` ${datosVarios.grado ? datosVarios.grado : "ciudadano"} ${datosVarios.apellidoNombre} - ${
      verificarString(datosVarios.dniCertificado) +
      " N° " +
      datosVarios.dniCertificado
    }`;


  const text3Clase1 =
    `Por haber participado de ${datosVarios.tituloCertificado}, en calidad de ${datosVarios.calidadDe}; ${datosVarios.organizadoPor} ${datosVarios.fechaRealizado}. `;


  // ============================================================
  // TEXTOS CLASE 4
  // ============================================================
  const text1Clase4 =
    `La Escuela de Investigaciones I.Se.P otorga el presente certificado al ${
      datosVarios.grado
        ? datosVarios.grado
        : "ciudadano"
    }`;


  const text2Clase4 =
    `  ${datosVarios.apellidoNombre} - ${
      verificarString(datosVarios.dniCertificado) +
      " N° " +
      datosVarios.dniCertificado
    }`;


  const text3Clase4 =
    ` por haber aprobado satisfactoriamente el ${datosVarios.tituloCertificado} - ${datosVarios.reginterno}, según Resolución ${datosVarios.resolucionCertificado}. El curso se desarrolló ${datosVarios.fechaRealizado} con una carga horaria total de ${datosVarios.cantidadHoras}. `;


  // ============================================================
  // TEXTOS TÍTULOS
  // ============================================================
  const ciudadMayuscula =
    (datosVarios.ciudadCertificado || "")
      .toUpperCase();


  // CLASE 1 USA CREATEDAT
  const text4Clase1 =
    `${ciudadMayuscula}: ${hoyCertificado}.`;


  const hoy = fechaFormal();


  const text1 =
    `Se hace constar que `;


  const text2 =
    `${datosVarios.apellidoNombre}, ${
      verificarString(datosVarios.dniCertificado) +
      " Nro. " +
      datosVarios.dniCertificado
    }, `;


  const text3 =
    `ha finalizado y aprobado sus estudios de “${datosVarios.tituloCertificado}” ${datosVarios.organizadoPor}. 
    `;


  const text3b =
    `ha finalizado y aprobado sus estudios de “${datosVarios.tituloCertificado}”, perteneciente a la Carrera de Técnico Superior en Seguridad Pública y Ciudadana con Orientacion Policial. en el establecimiento ${datosVarios.organizadoPor}. 
    `;


  const text4 =
    `Encontrándose en trámite la expedición de su título definitivo.`;



  // ============================================================
  // CLASE 1 A
  // ============================================================
  const clase1_a = () => (

    <Document
      title={
        "Certificado " +
        datosVarios.tituloCertificado +
        " " +
        datosVarios.apellidoNombre
      }
      onLoadError={console.error}
    >

      <Page
        size="A4"
        orientation='landscape'
      >

        <View
          style={{
            width: "100%",
            marginTop: "20px",
            marginLeft: "10px",
            padding: "1px"
          }}
        >

          <View
            id="Logos"
            style={{
              width: "100%",
              marginTop: "20px",
              padding: "1px"
            }}
          >

            <Image
              style={{
                width: "850px",
                position: "absolute",
                marginLeft: "-15px",
                marginTop: "-42px"
              }}
              src={bannerSuperior}
            />


            <Image
              style={{
                width: "85px",
                position: "absolute",
                marginLeft: "90px",
                marginTop: "20px"
              }}
              src={logoProvincia}
            />


            <Image
              style={{
                width: "320px",
                position: "absolute",
                marginTop: "40px",
                marginLeft: "450px"
              }}
              src={textoIsep}
            />

          </View>


          <Text
            style={{
              textAlign: "center",
              marginTop: "130px",
              paddingTop: "1px",
              fontSize: "32px",
              fontWeight: "bold"
            }}
          >
            C   E   R   T   I   F   I   C   A   D   O
          </Text>


          <View
            className='datosPersonales_legajo'
            style={{
              textAlign: "justify",
              marginLeft: "75px",
              marginRight: "85px",
              paddingTop: "1px",
              fontSize: "12px",
              lineHeight: "2"
            }}
          >

            <Text
              style={{
                textAlign: "justify",
                paddingTop: "1px",
                fontSize: "16px",
                lineHeight: "2",
                marginTop: "50px",
                color: "#333"
              }}
            >

              {text1Clase1}

              <Text
                style={{
                  textAlign: "justify",
                  fontSize: "18px",
                  color: "black"
                }}
              >

                {text2Clase1}

              </Text>

              {text3Clase1}

            </Text>


            <Text
              style={{
                textAlign: "rigth",
                fontSize: "16px",
                lineHeight: "2",
                color: "#333"
              }}
            >

              {text4Clase1}

            </Text>


            <Text
              style={{
                textAlign: "rigth",
                fontSize: "16px",
                lineHeight: "2"
              }}
            >
            </Text>


            <View
              id="firmaDardo"
              style={{
                width: "180px",
                position: "absolute",
                marginLeft: "350px",
                marginTop: "370px",
                lineHeight: "1",
                fontSize: "8px",
                textAlign: "center"
              }}
            >

              <Image
                style={{
                  width: "120px",
                  position: "absolute",
                  marginLeft: "20px",
                  marginTop: "-90px"
                }}
                src={firmaFunc}
              />

              <Text
                style={{
                  marginTop: "-10px"
                }}
              >
                {firmanteSimil}
              </Text>

              <Text
                style={{
                  textAlign: "center"
                }}
              >
                {firmanteFuncion}
              </Text>

              <Text>
                {firmanteDestino}
              </Text>

            </View>


            <View
              id="firmaDire"
              style={{
                width: "110px",
                position: "absolute",
                marginLeft: "180px",
                marginTop: "272px",
                lineHeight: "1",
                fontSize: "8px",
                textAlign: "center"
              }}
            >

              <Image
                src={datosVarios.firma1}
              />

              <Text
                style={{
                  marginTop: "-50px"
                }}
              >
                {datosVarios.firmante1}
              </Text>

              <Text
                style={{
                  textAlign: "center"
                }}
              >
                {datosVarios.firmante1jer}
              </Text>

              <Text>
                {datosVarios.firmante1cargo}
              </Text>

            </View>


            <View
              id="QR"
              style={{
                width: "150px",
                position: "absolute",
                marginLeft: "615px",
                marginTop: "280px"
              }}
            >

              <ImagenQR
                direccion={direccion}
                tamaño="110"
              />

            </View>

          </View>


          <View
            style={{
              fontWeight: "bold",
              textAlign: "center",
              fontSize: "6px",
              position: "absolute",
              marginTop: "550px"
            }}
          >

            <Text
              style={{
                fontSize: "8px",
                lineHeight: "2",
                marginLeft: "646px"
              }}
            >

              Nro. de Registro:
              {datosVarios.idCurso +
                "-" +
                datosVarios.idCursante +
                "-" +
                obtenerAnio(datosVarios.createdAt)}

            </Text>

          </View>


          <Image
            style={{
              width: "850px",
              position: "absolute",
              marginLeft: "-15px",
              marginTop: "565px"
            }}
            src={bannerInferior}
          />

        </View>

      </Page>

    </Document>
  );



  // ============================================================
  // CLASE 1
  // ============================================================
  const clase1 = () => (

    <Document
      title={
        "Certificado " +
        datosVarios.tituloCertificado +
        " " +
        datosVarios.apellidoNombre
      }
      onLoadError={console.error}
    >

      <Page
        size="A4"
        orientation='landscape'
      >

        <View
          style={{
            width: "100%",
            marginTop: "20px",
            marginLeft: "10px",
            padding: "1px"
          }}
        >

          <View
            id="Logos"
            style={{
              width: "100%",
              marginTop: "20px",
              padding: "1px"
            }}
          >

            <Image
              style={{
                width: "850px",
                position: "absolute",
                marginLeft: "-15px",
                marginTop: "-42px"
              }}
              src={bannerSuperior}
            />


            <Image
              style={{
                width: "85px",
                position: "absolute",
                marginLeft: "90px",
                marginTop: "-10px"
              }}
              src={logoProvincia}
            />


            <Image
              style={{
                width: "320px",
                position: "absolute",
                marginTop: "0px",
                marginLeft: "450px"
              }}
              src={textoIsep}
            />

          </View>


          <Text
            style={{
              textAlign: "center",
              marginTop: "100px",
              paddingTop: "1px",
              fontSize: "36px",
              fontWeight: "bold"
            }}
          >

            C E R T I F I C A D O

          </Text>


          <View
            className='datosPersonales_legajo'
            style={{
              textAlign: "justify",
              marginLeft: "75px",
              marginRight: "85px",
              paddingTop: "1px",
              fontSize: "12px",
              lineHeight: "2"
            }}
          >

            <Text
              style={{
                textAlign: "center",
                paddingTop: "1px",
                fontSize: "18px",
                lineHeight: "2",
                marginTop: "30px",
                color: "#333"
              }}
            >

              {text1Clase1}

            </Text>


            <Text
              style={{
                textAlign: "center",
                paddingTop: "1px",
                fontSize: "18px",
                lineHeight: "2",
                color: "#333"
              }}
            >

              <Text
                style={{
                  textAlign: "center",
                  fontSize: "18px",
                  color: "black"
                }}
              >

                {text2Clase1}

              </Text>

            </Text>


            <Text
              style={{
                textAlign: "justify",
                paddingTop: "1px",
                fontSize: "18px",
                lineHeight: "2",
                color: "#333"
              }}
            >

              {text3Clase1}

              <Text
                style={{
                  textAlign: "justify",
                  paddingTop: "1px",
                  fontSize: "16px",
                  lineHeight: "2",
                  color: "#333",
                  textDecoration: "underline"
                }}
              >

                Duración:

              </Text>

              {datosVarios.cantidadHoras}.

            </Text>


            <Text
              style={{
                textAlign: "rigth",
                fontSize: "16px",
                lineHeight: "2",
                color: "#333"
              }}
            >

              {text4Clase1}

            </Text>


            <Text
              style={{
                textAlign: "rigth",
                fontSize: "16px",
                lineHeight: "2"
              }}
            >
            </Text>


            <View
              id="firmaDardo"
              style={{
                width: "180px",
                position: "absolute",
                marginLeft: "350px",
                marginTop: "370px",
                lineHeight: "1",
                fontSize: "8px",
                textAlign: "center"
              }}
            >

              <Image
                style={{
                  width: "120px",
                  position: "absolute",
                  marginLeft: "20px",
                  marginTop: "-80px",
                  transform: 'rotate(90deg)'
                }}
                src={firmaFunc}
              />


              <Text
                style={{
                  marginTop: "-10px"
                }}
              >
                {firmanteSimil}
              </Text>


              <Text
                style={{
                  textAlign: "center"
                }}
              >
                {firmanteFuncion}
              </Text>


              <Text>
                {firmanteDestino}
              </Text>

            </View>


            <View
              id="firmaDire"
              style={{
                width: "110px",
                position: "absolute",
                marginLeft: "200px",
                marginTop: "372px",
                lineHeight: "1",
                fontSize: "8px",
                textAlign: "center"
              }}
            >

              <Image style={{
                  width: "120px",
                 
                  marginLeft: "1px",
                  marginTop: "-83px",
                 
                }}
                src={datosVarios.firma1}
              />

              <Text
                style={{
                  marginTop: "-32px"
                }}
              >
                {datosVarios.firmante1}
              </Text>

              <Text
                style={{
                  textAlign: "center"
                }}
              >
                {datosVarios.firmante1jer}
              </Text>

              <Text>
                {datosVarios.firmante1cargo}
              </Text>

            </View>


            <View
              id="QR"
              style={{
                width: "150px",
                position: "absolute",
                marginLeft: "615px",
                marginTop: "300px"
              }}
            >

              <ImagenQR
                direccion={direccion}
                tamaño="110"
              />

            </View>

          </View>


          <View
            style={{
              fontWeight: "bold",
              textAlign: "center",
              fontSize: "6px",
              position: "absolute",
              marginTop: "550px"
            }}
          >

            <Text
              style={{
                fontSize: "8px",
                lineHeight: "2",
                marginLeft: "646px"
              }}
            >

              Nro. de Registro:
              {datosVarios.idCurso +
                "-" +
                datosVarios.idCursante +
                "-" +
                obtenerAnio(datosVarios.createdAt)}

            </Text>

          </View>


          <Image
            style={{
              width: "850px",
              position: "absolute",
              marginLeft: "-15px",
              marginTop: "565px"
            }}
            src={bannerInferior}
          />

        </View>

      </Page>

    </Document>
  );



  // ============================================================
  // CLASE 2
  // CERTIFICADO TÍTULOS EN TRÁMITE
  // ============================================================
  const clase2 = () => (

    <Document
      title={
        "Certificado " +
        datosVarios.tituloCertificado +
        " " +
        datosVarios.apellidoNombre
      }
      onLoadError={console.error}
    >

      <Page size="A4">

        <View
          style={{
            width: "100%",
            marginTop: "20px",
            marginLeft: "10px",
            padding: "1px"
          }}
        >

          <View
            id="Logos"
            style={{
              width: "100%",
              marginTop: "20px",
              padding: "1px"
            }}
          >

            <Text
              style={{
                textAlign: "center",
                marginTop: "10px",
                paddingTop: "1px",
                fontSize: "8px",
                fontWeight: "bold",
                position: "absolute",
                marginLeft: "150px"
              }}
            >

              Alem 2050 – CP 2000 Rosario - www.isepsantafe.edu.ar – titulosisep@isepsantafe.edu.ar

            </Text>


            <Image
              style={{
                width: "650px",
                position: "absolute",
                marginLeft: "-15px",
                marginTop: "-42px"
              }}
              src={bannerSuperior}
            />


            <Image
              style={{
                width: "65px",
                position: "absolute",
                marginLeft: "60px",
                marginTop: "20px"
              }}
              src={logoProvincia}
            />


            <Image
              style={{
                width: "280px",
                position: "absolute",
                marginTop: "40px",
                marginLeft: "290px"
              }}
              src={textoIsep}
            />

          </View>


          <Text
            style={{
              textAlign: "center",
              marginTop: "130px",
              paddingTop: "1px",
              fontSize: "32px",
              fontWeight: "bold"
            }}
          >

            Certificación

          </Text>


          <View
            className='datosPersonales_legajo'
            style={{
              textAlign: "justify",
              marginLeft: "75px",
              marginRight: "85px",
              paddingTop: "1px",
              fontSize: "12px",
              lineHeight: "2"
            }}
          >

            <Text
              style={{
                textAlign: "justify",
                paddingTop: "1px",
                lineHeight: "2",
                marginTop: "50px",
                color: "#333"
              }}
            >

              {text1}

              <Text
                style={{
                  textAlign: "justify",
                  fontSize: "12px",
                  color: "black"
                }}
              >

                {text2}

              </Text>

              {text3}

              {text4}

            </Text>


            <Text>
              CUE: 8204429-01.-
            </Text>


            <Text>
              Fecha de Egreso {datosVarios.fechaRealizado}.-
            </Text>


            <Text>
              Cohorte {datosVarios.reginterno}.
            </Text>


            <Text>
              Plan de Estudios:{datosVarios.resolucionJPP}.-
            </Text>


            <Text>
              Total Horas Cátedras: {datosVarios.cantidadHoras}.-
            </Text>


            <Text
              style={{
                textAlign: "rigth",
                lineHeight: "2",
                color: "#333"
              }}
            >

              A pedido del interesado se extiende la presente constancia en {datosVarios.ciudadCertificado}, {fechaCompletaCertificado}, para ser presentado ante quien corresponda.

            </Text>


            <Text
              style={{
                textAlign: "rigth",
                fontSize: "16px",
                lineHeight: "2"
              }}
            >
            </Text>


            <View
              id="firmaDardo"
              style={{
                width: "180px",
                position: "absolute",
                marginLeft: "230px",
                marginTop: "470px",
                lineHeight: "1",
                fontSize: "8px",
                textAlign: "center"
              }}
            >

              <Image
                style={{
                  width: "120px",
                  position: "absolute",
                  marginLeft: "20px",
                  marginTop: "-90px"
                }}
                src={firmaFunc}
              />

              <Text
                style={{
                  marginTop: "-10px"
                }}
              >
                {firmanteSimil}
              </Text>

              <Text
                style={{
                  textAlign: "center"
                }}
              >
                {firmanteFuncion}
              </Text>

              <Text>
                {firmanteDestino}
              </Text>

            </View>


            <View
              id="firmaDire"
              style={{
                width: "110px",
                position: "absolute",
                marginLeft: "40px",
                marginTop: "372px",
                lineHeight: "1",
                fontSize: "8px",
                textAlign: "center"
              }}
            >

              <Image
                src={datosVarios.firma1}
              />

              <Text
                style={{
                  marginTop: "-10px"
                }}
              >
                {datosVarios.firmante1}
              </Text>

              <Text
                style={{
                  textAlign: "center"
                }}
              >
                {datosVarios.firmante1jer}
              </Text>

              <Text>
                {datosVarios.firmante1cargo}
              </Text>

            </View>


            <View
              id="QR"
              style={{
                width: "150px",
                position: "absolute",
                marginLeft: "400px",
                marginTop: "530px"
              }}
            >

              <ImagenQR
                direccion={direccion}
                tamaño="110"
              />

            </View>

          </View>


          <View
            style={{
              fontWeight: "bold",
              textAlign: "center",
              fontSize: "6px",
              position: "absolute",
              marginTop: "800px"
            }}
          >

            <Text
              style={{
                fontSize: "8px",
                lineHeight: "2",
                marginLeft: "456px"
              }}
            >

              Nro. de Registro:
              {datosVarios.idCurso +
                "-" +
                datosVarios.idCursante +
                "-" +
                obtenerAnio(datosVarios.createdAt)}

            </Text>

          </View>


          <Image
            style={{
              width: "850px",
              position: "absolute",
              marginLeft: "-15px",
              marginTop: "810px"
            }}
            src={bannerInferior}
          />

        </View>

      </Page>

    </Document>
  );



  // ============================================================
  // CLASE 3
  // CERTIFICADO EXTENSIÓN COMUNITARIA
  // ============================================================
  const clase3 = () => (

    <Document
      title={
        "Certificado " +
        datosVarios.tituloCertificado +
        " " +
        datosVarios.apellidoNombre
      }
      onLoadError={console.error}
    >

      <Page size="A4">

        <View
          style={{
            width: "100%",
            marginTop: "20px",
            marginLeft: "10px",
            padding: "1px"
          }}
        >

          <View
            id="Logos"
            style={{
              width: "100%",
              marginTop: "20px",
              padding: "1px"
            }}
          >

            <Text
              style={{
                textAlign: "center",
                marginTop: "10px",
                paddingTop: "1px",
                fontSize: "8px",
                fontWeight: "bold",
                position: "absolute",
                marginLeft: "150px"
              }}
            >

              Alem 2050 – CP 2000 Rosario - www.isepsantafe.edu.ar – titulosisep@isepsantafe.edu.ar

            </Text>


            <Image
              style={{
                width: "650px",
                position: "absolute",
                marginLeft: "-15px",
                marginTop: "-42px"
              }}
              src={bannerSuperior}
            />


            <Image
              style={{
                width: "65px",
                position: "absolute",
                marginLeft: "60px",
                marginTop: "20px"
              }}
              src={logoProvincia}
            />


            <Image
              style={{
                width: "280px",
                position: "absolute",
                marginTop: "40px",
                marginLeft: "290px"
              }}
              src={textoIsep}
            />

          </View>


          <Text
            style={{
              textAlign: "center",
              marginTop: "130px",
              paddingTop: "1px",
              fontSize: "32px",
              fontWeight: "bold"
            }}
          >

            Certificación

          </Text>


          <View
            className='datosPersonales_legajo'
            style={{
              textAlign: "justify",
              marginLeft: "75px",
              marginRight: "85px",
              paddingTop: "1px",
              fontSize: "12px",
              lineHeight: "2"
            }}
          >

            <Text
              style={{
                textAlign: "justify",
                paddingTop: "1px",
                lineHeight: "2",
                marginTop: "50px",
                color: "#333"
              }}
            >

              {text1}

              <Text
                style={{
                  textAlign: "justify",
                  fontSize: "12px",
                  color: "black"
                }}
              >

                {text2}

              </Text>

              {text3b}

            </Text>


            <Text>
              CUE: 8204429-01.-
            </Text>


            <Text>
              Cohorte {datosVarios.reginterno}.
            </Text>


            <Text>
              Plan de Estudios:{datosVarios.resolucionJPP}.-
            </Text>


            <Text
              style={{
                textAlign: "rigth",
                lineHeight: "2",
                color: "#333"
              }}
            >

              A pedido del interesado se extiende la presente constancia en {datosVarios.ciudadCertificado}, {fechaCompletaCertificado}, para ser presentado ante quien corresponda.

            </Text>


            <Text
              style={{
                textAlign: "rigth",
                fontSize: "16px",
                lineHeight: "2"
              }}
            >
            </Text>


            <View
              id="firmaDardo"
              style={{
                width: "180px",
                position: "absolute",
                marginLeft: "350px",
                marginTop: "370px",
                lineHeight: "1",
                fontSize: "8px",
                textAlign: "center"
              }}
            >

              <Image
                style={{
                  width: "120px",
                  position: "absolute",
                  marginLeft: "20px",
                  marginTop: "-90px"
                }}
                src={firmaFunc}
              />

              <Text
                style={{
                  marginTop: "-10px"
                }}
              >
                {firmanteSimil}
              </Text>

              <Text
                style={{
                  textAlign: "center"
                }}
              >
                {firmanteFuncion}
              </Text>

              <Text>
                {firmanteDestino}
              </Text>

            </View>


            <View
              id="firmaDire"
              style={{
                width: "110px",
                position: "absolute",
                marginLeft: "180px",
                marginTop: "272px",
                lineHeight: "1",
                fontSize: "8px",
                textAlign: "center"
              }}
            >

              <Image
                src={datosVarios.firma1}
              />

              <Text
                style={{
                  marginTop: "-10px"
                }}
              >
                {datosVarios.firmante1}
              </Text>

              <Text
                style={{
                  textAlign: "center"
                }}
              >
                {datosVarios.firmante1jer}
              </Text>

              <Text>
                {datosVarios.firmante1cargo}
              </Text>

            </View>


            <View
              id="QR"
              style={{
                width: "150px",
                position: "absolute",
                marginLeft: "400px",
                marginTop: "530px"
              }}
            >

              <ImagenQR
                direccion={direccion}
                tamaño="110"
              />

            </View>

          </View>


          <View
            style={{
              fontWeight: "bold",
              textAlign: "center",
              fontSize: "6px",
              position: "absolute",
              marginTop: "800px"
            }}
          >

            <Text
              style={{
                fontSize: "8px",
                lineHeight: "2",
                marginLeft: "456px"
              }}
            >

              Nro. de Registro:
              {datosVarios.idCurso +
                "-" +
                datosVarios.idCursante +
                "-" +
                obtenerAnio(datosVarios.createdAt)}

            </Text>

          </View>


          <Image
            style={{
              width: "850px",
              position: "absolute",
              marginLeft: "-15px",
              marginTop: "810px"
            }}
            src={bannerInferior}
          />

        </View>

      </Page>

    </Document>
  );



  // ============================================================
  // CLASE 4
  // CERTIFICADO SECRETARÍA ACADÉMICA
  // ============================================================
  const clase4 = () => (

    <Document
      title={
        "Certificado " +
        datosVarios.tituloCertificado +
        " " +
        datosVarios.apellidoNombre
      }
      onLoadError={console.error}
    >

      <Page
        size="A4"
        orientation='landscape'
      >

        <View
          style={{
            width: "100%",
            marginTop: "20px",
            marginLeft: "10px",
            padding: "1px"
          }}
        >

          <View
            id="Logos"
            style={{
              width: "100%",
              marginTop: "20px",
              padding: "1px"
            }}
          >

            <Image
              style={{
                width: "850px",
                position: "absolute",
                marginLeft: "-12px",
                marginTop: "-42px"
              }}
              src={bannerSuperior}
            />


            <Image
              style={{
                width: "85px",
                position: "absolute",
                marginLeft: "90px",
                marginTop: "-10px"
              }}
              src={logoProvincia}
            />


            <Image
              style={{
                width: "320px",
                position: "absolute",
                marginTop: "0px",
                marginLeft: "450px"
              }}
              src={textoIsep}
            />

          </View>


          <Text
            style={{
              textAlign: "center",
              marginTop: "100px",
              paddingTop: "1px",
              fontSize: "28px",
              fontWeight: "bold"
            }}
          >

            CERTIFICADO DE FINALIZACIÓN DE CURSO

          </Text>


          <View
            className='datosPersonales_legajo'
            style={{
              textAlign: "justify",
              marginLeft: "75px",
              marginRight: "85px",
              marginTop: "10px",
              paddingTop: "1px",
              fontSize: "12px",
              lineHeight: "2"
            }}
          >

            <Text
              style={{
                textAlign: "justify",
                paddingTop: "1px",
                fontSize: "16px",
                lineHeight: "2",
                marginTop: "30px",
                color: "#333"
              }}
            >

              {text1Clase4}

              <Text
                style={{
                  textAlign: "justify",
                  fontSize: "16px",
                  color: "black"
                }}
              >

                {text2Clase4}

              </Text>

              {text3Clase4}

            </Text>


            {/* =================================================
                CLASE 4 TAMBIÉN USA certificado.createdAt
               ================================================= */}

            <Text
              style={{
                textAlign: "justify",
                paddingTop: "1px",
                fontSize: "16px",
                lineHeight: "2",
                color: "#333"
              }}
            >

              Se extiende el presente en la ciudad de {ciudadMayuscula + ": " + hoyCertificado + "."}

            </Text>


            <Text
              style={{
                textAlign: "rigth",
                fontSize: "16px",
                lineHeight: "2"
              }}
            >
            </Text>


            <View
              id="firmaDire"
              style={{
                width: "110px",
                position: "absolute",
                marginLeft: "500px",
                marginTop: "252px",
                lineHeight: "1",
                fontSize: "8px",
                textAlign: "center"
              }}
            >

              <Image
                src={datosVarios.firma1}
              />

              <Text
                style={{
                  marginTop: "-10px"
                }}
              >
                {datosVarios.firmante1}
              </Text>

              <Text
                style={{
                  textAlign: "center"
                }}
              >
                {datosVarios.firmante1jer}
              </Text>

              <Text>
                {datosVarios.firmante1cargo}
              </Text>

            </View>


            <View
              id="QR"
              style={{
                width: "150px",
                position: "absolute",
                marginLeft: "615px",
                marginTop: "300px"
              }}
            >

              <ImagenQR
                direccion={direccion}
                tamaño="110"
              />

            </View>

          </View>


          <View
            style={{
              fontWeight: "bold",
              textAlign: "center",
              fontSize: "6px",
              position: "absolute",
              marginTop: "550px"
            }}
          >

            <Text
              style={{
                fontSize: "8px",
                lineHeight: "2",
                marginLeft: "646px"
              }}
            >

              Nro. de Registro:
              {datosVarios.idCurso +
                "-" +
                datosVarios.idCursante +
                "-" +
                obtenerAnio(datosVarios.createdAt)}

            </Text>

          </View>


          <Image
            style={{
              width: "850px",
              position: "absolute",
              marginLeft: "-15px",
              marginTop: "565px"
            }}
            src={bannerInferior}
          />

        </View>

      </Page>

    </Document>
  );


  // ============================================================
  // CLASES
  // ============================================================
  const clases = {

    clase1,

    clase2,

    clase3,

    clase4,
  };


  const claseCertificados =
    datosVarios.claseCertificado;


  const MyDocument =
    clases[claseCertificados];


  // ============================================================
  // GENERAR PDF
  // ============================================================
  const generatePdfDocument = async () => {

    try {

      const nombreArchivo =
        "Certificado " +
        datosVarios.tituloCertificado +
        " " +
        datosVarios.apellidoNombre;


      const doc =
        <MyDocument />;


      const blob =
        await pdf(doc).toBlob();


      saveAs(
        blob,
        nombreArchivo
      );

    } catch (error) {

      console.log(error);
    }
  };


  // ============================================================
  // RENDER
  // ============================================================
  return (
    <>

      {muestro ? (

        <>

          {width < 480 ? (

            <div
              style={{
                textAlign: "center"
              }}
            >

              <img
                src={Logo}
                style={{
                  width: "100px"
                }}
                alt="Logo"
              />


              <h1>

                Descargue su certificado {datosVarios.apellidoNombre}

              </h1>


              <button
                className="btn btn-primary"
                onClick={generatePdfDocument}
              >

                DESCARGAR

              </button>

            </div>

          ) : (

            <PDFViewer
              showToolbar={false}
              style={{
                width: "100%",
                height: "100vh"
              }}
            >

              <MyDocument />

            </PDFViewer>

          )}

        </>

      ) : (

        <>

          {Er ? (

            <div
              style={{
                textAlign: 'center',
                margin: "10px",
                border: "1px solid red",
                padding: "5px"
              }}
            >

              <img
                src={logoProvincia}
                width="120px"
                alt="Escudo"
              />


              <h1
                style={{
                  textAlign: 'center',
                  marginTop: '10px',
                  color: "red"
                }}
              >

                Error al obtener los datos o datos Invalidos

              </h1>


              <h7>

                comuniquese al area que extendio el mismo si considera que es un error

              </h7>

            </div>

          ) : ""}

        </>

      )}

    </>
  );
}


export default Constancia;
